import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractList} from '../abstract-list';
import {ExpertiseFilter, ExpertiseSettings} from './list';

/**
 * Expertise overview.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Overview extends AbstractList<ExpertiseFilter, ExpertiseSettings> {
  private expertisesOverviewModal: HTMLDivElement | null = null;

  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('expertise-overview', this);
  }

  /**
   * Finds expertises.
   */
  protected find(): void {
    DataApi.instance.expertiseEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/expertise/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        // Move modal outside before the closing body tag, so that z-index and proper overlay is guaranteed
        this.expertisesOverviewModal = this.container.querySelector<HTMLDivElement>('#expertises-overview-modal');
        if (this.expertisesOverviewModal) {
          document.body.append(this.expertisesOverviewModal);
        }

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
